  import React, { useState, useEffect, useRef } from "react";
  import Slider from "react-slick";
  import "slick-carousel/slick/slick.css"; 
  import "slick-carousel/slick/slick-theme.css";
  import { useLanguage } from '../contexts/LanguageContext';
  import { optimizedSrc, optimizedSrcSet } from '../config/optimizedImages';
  // import './Intro2nd.css';

  const Intro2nd = () => {
    const { t, language } = useLanguage();
    const measureRef = useRef(null);
    const [cardMinHeight, setCardMinHeight] = useState(0);
    useEffect(() => {
      const importCss = async () => {
        try {
          await import('./Intro2nd.css');//replacing the css with the css of the gallery of the suites
        } catch (err) {}
      };
      importCss();
    }, []);
    const [activeIndex, setActiveIndex] = useState(0);

    const featureKeys = ['feature1', 'feature2', 'feature3'];

    useEffect(() => {
      let cancelled = false;
      const updateCardMinHeight = () => {
        const measureRoot = measureRef.current;
        if (!measureRoot || cancelled) return;
        const featureEl =
          document.querySelector('.Intro2nd-container .slick-center .feature') ||
          document.querySelector('.Intro2nd-container .slick-current .feature') ||
          document.querySelector('.Intro2nd-container .feature');
        if (featureEl && featureEl.clientWidth > 0) {
          measureRoot.style.width = `${featureEl.clientWidth}px`;
          measureRoot.style.maxWidth = 'none';
        }
        const contentHeights = Array.from(measureRoot.children).map(
          (el) => el.offsetHeight
        );
        const maxContent = Math.max(0, ...contentHeights);
        if (maxContent > 0) {
          setCardMinHeight(350 + maxContent + 16);
        }
      };

      const timeouts = [0, 80, 250, 700].map((ms) =>
        window.setTimeout(updateCardMinHeight, ms)
      );
      window.addEventListener('resize', updateCardMinHeight);
      const observer = new ResizeObserver(updateCardMinHeight);
      const container = document.querySelector('.Intro2nd-container');
      if (container) observer.observe(container);

      return () => {
        cancelled = true;
        timeouts.forEach((id) => window.clearTimeout(id));
        window.removeEventListener('resize', updateCardMinHeight);
        observer.disconnect();
      };
    }, [language]);

    const settings = {
      dots: true,
      infinite: true,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: getCenterPadding(),
      speed: 500,
      adaptiveHeight: false,
      className: "slider",
      beforeChange: (current, next) => setActiveIndex(next),
    };
    function getCenterPadding() {
      const screenWidth = window.innerWidth;
      if (screenWidth >= 1200) {
        return "200px"; // Adjust this value for desktop
      } else if (screenWidth >= 768) {
        return "100px"; // Adjust this value for tablets
      } else {
        return "30px"; // No padding for mobile
      }
    }
    
    return (
      <div
        className="Intro2nd-container"
        style={cardMinHeight ? { '--intro2nd-card-min': `${cardMinHeight}px` } : undefined}
      >
        <div className="intro2nd-measure" ref={measureRef} aria-hidden="true">
          {featureKeys.map((key) => (
            <div key={key} className="intro2nd-measure-block">
              <h4>{t(`intro2nd.${key}.title`)}</h4>
              <p>{t(`intro2nd.${key}.description`)}</p>
            </div>
          ))}
        </div>
        <Slider {...settings}>
          <div className="feature">
            <div className="featu-img">
              <img
                src={optimizedSrc('711A8132')}
                srcSet={optimizedSrcSet('711A8132')}
                sizes="(max-width: 768px) 100vw, 800px"
                loading="lazy"
                decoding="async"
                alt={t('intro2nd.feature1.altText')}
              />
            </div>
            <h4>{t('intro2nd.feature1.title')}</h4>
            <p className={activeIndex === 0 ? "open" : "closed-paragraph"}>
              {t('intro2nd.feature1.description')}
            </p>
          </div>
          <div className="feature">
            <div className="featu-img">
              <img
                src={optimizedSrc('711A8143')}
                srcSet={optimizedSrcSet('711A8143')}
                sizes="(max-width: 768px) 100vw, 800px"
                loading="lazy"
                decoding="async"
                alt={t('intro2nd.feature2.altText')}
              />
            </div>
            <h4>{t('intro2nd.feature2.title')}</h4>
            <p className={activeIndex === 1 ? "open" : "closed-paragraph"}>
              {t('intro2nd.feature2.description')}
            </p>
          </div>
          <div className="feature">
            <div className="featu-img">
              <img
                src={optimizedSrc('711A8279')}
                srcSet={optimizedSrcSet('711A8279')}
                sizes="(max-width: 768px) 100vw, 800px"
                loading="lazy"
                decoding="async"
                alt={t('intro2nd.feature3.altText')}
              />
            </div>
            <h4>{t('intro2nd.feature3.title')}</h4>
            <p className={activeIndex === 2 ? "open" : "closed-paragraph"}>
              {t('intro2nd.feature3.description')}
            </p>
          </div>
        </Slider>
      </div>
    );
  };

  export default Intro2nd;
